import { pluck as untypedPluck } from "rxjs/operators";
export function pluck(...keys) {
    return (source) => untypedPluck(...keys)(source);
}
//# sourceMappingURL=pluck.js.map